<template>
  <BaseTemplate>
    <div>
      <router-view></router-view>
    </div>
  </BaseTemplate>
</template>

<script>
import BaseTemplate from "@/views/common/BaseTemplate.vue";

export default {
  components: {
    BaseTemplate
  }
};
</script>



// WEBPACK FOOTER //
// src/views/omikujiTest/OmikujiTestRoute.vue